import AddToCart from 'Component/AddToCart';

const renderAddToCartButton = (args, callback, instance) => {
    const {
        addToCart,
        inStock,
        quantity,
        getActiveProduct,
        originalProduct
    } = instance.props;

    return (
        <AddToCart
          mix={ { block: instance.className, elem: 'AddToCart' } }
          addToCart={ addToCart }
          isDisabled={ !inStock }
          isIconEnabled={ false }
          layout={ args.layout }
          quantity={ quantity }
          product={ getActiveProduct() }
          originalProduct={ originalProduct }
        />
    );
};

export default {
    'Component/Product/Component': {
        'member-function': {
            renderAddToCartButton
        }
    }
};
